import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import S from './MainPopup.module.css';
import Draggable from 'react-draggable';

import { fetchPopupListData } from '../../services/mainService';
import { popupTItle } from '../../assets/images/main/mainImages';

const MainPopup = () => {
  
  const [showPopup, setShowPopup] = useState(true);
  const [hidePopupToday, setHidePopupToday] = useState(false);
  const [popupData, setPopupData] = useState([]);

  useEffect(() => {
    (async () => {
      const popData = await fetchPopupListData(null);
      setPopupData(popData || []);
    })();
  }, []);

  useEffect(() => {
    const raw = localStorage.getItem('popupClosedToday');
    if (!raw) return;
  
    const now = Date.now();
    const expires = Number(raw);
  
    if (Number.isFinite(expires) && now <= expires) {
      setShowPopup(false);
    } else {
      localStorage.removeItem('popupClosedToday');
      setShowPopup(true);
    }
  }, []);

  const handleClosePopup = () => {
    if (hidePopupToday) {
      const end = new Date();
      end.setHours(23, 59, 59, 999);
      localStorage.setItem('popupClosedToday', String(end.getTime()));
    }
    setShowPopup(false);
  };

  return (
    <>
      {showPopup && popupData.length > 0 && (
	    <Draggable>
			<div id={S.popWrap}>
			  <div className='popup'>
				<div id={S.popTitle}>
				  <img src={popupTItle} alt='title'/>
				</div>
				<div id={popupData.length!==4 ? S.popBodyA : S.popBodyB}>
				  {popupData && popupData.map((item, index) => (
					<div className={S.popCon} key={index}>
					  <Link to={item.P_LINK} target="_blank">
              <img className={S.popImg} src={item.P_IMG_PATH} alt='test'/>
            </Link>
					</div>
				  ))}
				</div>
				<div id={S.popBtnWrap}>
				  <label className='cursor'>
					<input
					  id={S.checkInput}
					  type="checkbox"
					  checked={hidePopupToday}
					  onChange={(e) => setHidePopupToday(e.target.checked)}
					/>
					오늘 하루 안보기
				  </label>
				  <button id={S.closeBtn} onClick={handleClosePopup}>닫기</button>
				</div>
			  </div>
			</div>
		  </Draggable>
      )} 
    </>
  );
}

export default MainPopup;
